import { Icon } from '@iconify/react';
import styled from 'styled-components';
import FormControl from '../../../components/form_control';
import ShowImage from '../../../components/show_image';
import { ChangeEvent } from 'react';
import { ImageType } from '../../../data/types/files';
import { MODAL_CONSTANTS } from '../constants';
import { Flex, Input } from 'antd';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  useDisclosure,
} from '@nextui-org/react';

type SelectedImagesModalProps = {
  setSelectedImage: (image: any) => void;
  closeModals: (is_cancel?: boolean) => void;
  edit_able_images: any[];
  selected_index: number;
  selected_image: ImageType | undefined;
  next: (is_modal_delete: boolean) => void;
  is_modal_delete: boolean;
  current_modal: MODAL_CONSTANTS;
  is_open: boolean;
};
export function SelectedImagesModal({
  setSelectedImage,
  closeModals,
  edit_able_images,
  selected_index,
  selected_image,
  next,
  is_modal_delete,
  current_modal,
  is_open,
}: SelectedImagesModalProps) {
  return (
    <>
      <Modal
        isOpen={is_open}
        onClose={() => {
          closeModals(false);
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">
                {current_modal.title}
                <br />
                {current_modal.title_after_break} ({selected_index + 1}/
                {edit_able_images?.length})
              </ModalHeader>
              <ModalBody>
                <div className="body">
                  <div className="text">
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        height: '100%',
                        border: '2px solid gray',
                        marginBottom: '15px',
                        borderRadius: '5px',
                      }}
                    >
                      <ShowImage
                        image={selected_image}
                        style={{
                          width: '379px',
                          height: '235px',
                          minWidth: '379px',
                          minHeight: '235px',
                        }}
                      />
                    </div>

                    {is_modal_delete ? null : (
                      <Input
                        placeholder="Image alt"
                        value={selected_image?.alt || ''}
                        onChange={(e) =>
                          setSelectedImage({
                            ...selected_image,
                            alt: e.target.value,
                          })
                        }
                        size="large"
                      />
                    )}
                  </div>

                  <div className="buttons"></div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="default"
                  onPress={() => {
                    onClose();
                    closeModals(true);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  color={is_modal_delete ? 'danger' : 'warning'}
                  onPress={() => next(is_modal_delete)}
                >
                  {edit_able_images[selected_index + 1]
                    ? 'Next'
                    : current_modal.approve}
                </Button>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
